// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"23806db2","476":"7b2a3f68","562":"02b79e3c","871":"681d0aa5","950":"cbdad4c9"}[chunkId] + ".chunk.js";
};